export enum Severity {
    Primary,
    Secondary,
    Tertiary,
    Info,
    Success,
    Warning,
    Danger
}